import { useLocation, useParams, Navigate } from "react-router-dom";
import { StaticPageLayout } from "./StaticPage";
import { staticPagePaths, staticPages } from "@/content/static-pages";
import { useCmsPageBySlug } from "@/hooks/queries";
import { Skeleton } from "@/components/ui/skeleton";

const StaticPageRoute = () => {
  const { pathname } = useLocation();
  const { slug: paramSlug } = useParams<{ slug: string }>();
  const slug = paramSlug ?? staticPagePaths[pathname] ?? "";
  const fallback = slug ? staticPages[slug] : undefined;
  const { data: cmsPage, isLoading, isError } = useCmsPageBySlug(slug, Boolean(slug));

  if (!slug && !fallback) return <Navigate to="/" replace />;

  if (isLoading && !fallback) {
    return (
      <div className="container mx-auto px-4 py-12 max-w-3xl space-y-4">
        <Skeleton className="h-10 w-2/3" />
        <Skeleton className="h-4 w-1/2" />
        <Skeleton className="h-32 w-full" />
      </div>
    );
  }

  const page = cmsPage && !isError
    ? {
        title: cmsPage.title,
        subtitle: cmsPage.subtitle,
        content: <div dangerouslySetInnerHTML={{ __html: cmsPage.contentHtml }} />,
        cta: cmsPage.ctaLabel && cmsPage.ctaUrl ? { label: cmsPage.ctaLabel, to: cmsPage.ctaUrl } : undefined,
      }
    : fallback;

  if (!page) return <Navigate to="/" replace />;

  return (
    <StaticPageLayout title={page.title} subtitle={page.subtitle} cta={page.cta}>
      {page.content}
      {!cmsPage && fallback && (
        <p className="text-xs text-muted-foreground mt-6">
          Showing bundled content. Publish this page via the CMS API to serve it from the database.
        </p>
      )}
    </StaticPageLayout>
  );
};

export default StaticPageRoute;
